import eventMessage from 'src/components/event-message';
import { RESOURCE_TYPE } from 'src/constant';
import EVENT_MSG_TYPE from 'src/constant/event-msg-type';
import { win } from 'src/global';
import { IHBReqEvent } from 'src/types/type';
import { safetyResUrl } from 'src/utils';
import safeInvoke from 'src/utils/safe-invoke';

const Xhr = win.XMLHttpRequest;

export function wrapXhr() {
  // @ts-ignore
  if(Xhr.HBPROXY) {return;}
  // @ts-ignore
  Xhr.HBPROXY = true;
  const realOpen = Xhr.prototype.open;
  const realSend = Xhr.prototype.send;
  Xhr.prototype.open = function (method: string, url: string) {
    const self = this;
    const hbReqEvent: IHBReqEvent = self.__hbReqEvent = {
      rtype: RESOURCE_TYPE.XHR,
      _wait: true,
      m: method,
      rurl: safetyResUrl(url),
    };
    safeInvoke(self, self.addEventListener, 'readystatechange', () => {
      switch (self.readyState) {
      case 4:
        hbReqEvent._wait = false;
        hbReqEvent.txre = Date.now();
        hbReqEvent.sat = self.status;
        hbReqEvent._relativeTimeEnd = performance.now(), // 结束点的相对时间值
        hbReqEvent._resHeaders = self.getAllResponseHeaders();
        if(/^(0|([45]\d\d))$/.test(self.status)) {
          hbReqEvent.msg = hbReqEvent._err = `服务异常：${self.status}`;
        }
        break;
      default:
        break;
      }
    });
    safeInvoke(self, self.addEventListener, 'loadend', () => {
      hbReqEvent._wait = false;
      if(hbReqEvent._onWaitBack) {
        hbReqEvent._onWaitBack();
      }
    });
    safeInvoke(self, self.addEventListener, 'error', (ev: any) => {
      hbReqEvent.msg = hbReqEvent._err = ev.type || 'unknown error';
    });
    safeInvoke(self, self.addEventListener, 'abort', () => {
      hbReqEvent.msg = hbReqEvent._err = 'abort';
    });
    realOpen.apply(self, arguments);
  };
  Xhr.prototype.send = function () {
    const self = this;
    const hbReqEvent = self.__hbReqEvent;
    try {
      if(hbReqEvent) {
        Object.assign(hbReqEvent, {
          txrs: Date.now(),
          _relativeTimeStart: performance.now(), // 开始点的相对时间值
          _reqBody: arguments[0]
        });
        // 延时放入队列，避免早于点击事件
        setTimeout(() => {
          eventMessage.publish<IHBReqEvent>({
            time: hbReqEvent.txrs,
            type: EVENT_MSG_TYPE.XHR,
            data: hbReqEvent,
          });
        }, 1);
      }
    } catch (err) {
      hbLogger.error(err);
    }
    realSend.apply(self, arguments);
  };
}
